/* ============================================================================
   ecofuego-lp-builder.js — the bundle builder on the landing pages.

   Reads the chosen pit, fuel option and add-ons, keeps a running total, and
   posts every line to /cart/add.js in ONE request.

   TWO KINDS OF DISCOUNT, AND THEY WORK DIFFERENTLY
   ------------------------------------------------------------------------
   · Fuel quantity (10% at two, 15% at four) is DISPLAY ONLY here. Shopify
     charges the component total; the reduction comes from a Kaching Bundles
     rule that fires on cart contents. If the Kaching rule for the chosen pit
     does not exist, the cart will be higher than the number this shows.
   · The subscription is a real Shopify selling plan. Its price is applied by
     Shopify at checkout because the line carries selling_plan. Nothing has to
     be kept in sync for that one.

   THE STICKY BAR IS THE SECOND HALF OF THIS BUILDER
   ------------------------------------------------------------------------
   The bar at the foot of the page mirrors the running total, and once the
   visitor has touched the builder its button stops being a link to #offer
   and starts adding the configured bundle. Both buttons run the same add(),
   so there is one code path to the cart, not two. See paint() and ctas().

   All maths is in integer pence. Never use floats for money — 26.99 * 4 in
   binary floating point is 107.96000000000001, and that renders as £107.96
   until the day it doesn't.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-ef-builder]');
  if (!root) return;

  var money = (function () {
    var sym = root.dataset.currency || '£';
    return function (pence) {
      var n = (pence / 100).toFixed(2);
      return sym + n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };
  })();

  var el = {
    lines: root.querySelector('[data-ef-lines]'),
    total: root.querySelector('[data-ef-total]'),
    save:  root.querySelector('[data-ef-save]'),
    cta:   root.querySelector('[data-ef-add]'),
    err:   root.querySelector('[data-ef-err]'),
    stickyTitle: document.querySelector('[data-ef-sticky-title]'),
    stickySub:   document.querySelector('[data-ef-sticky-sub]'),
    stickyBtn:   document.querySelector('.ef-lp-sticky .ef-lp__btn')
  };
  if (el.stickySub) el.stickySub.dataset.base = el.stickySub.textContent.trim();
  if (el.stickyBtn) el.stickyBtn.dataset.base = el.stickyBtn.textContent.trim();

  /* Has the visitor actually touched the builder?
     A pit and the four-pack are both pre-checked in Liquid, so a valid basket
     exists before anyone has done anything. Switching the sticky bar to "Add
     to cart" on validity alone would therefore offer to buy a configuration
     nobody chose — most importantly a fire pit that is just the first one in
     the list. So the bar only becomes a buy button once a change event has
     come out of the builder. Until then it stays a link to the builder. */
  var engaged = false;

  function pit()   { return root.querySelector('input[name="ef-pit"]:checked'); }
  function fuel()  { return root.querySelector('input[name="ef-fuel"]:checked'); }
  function addons(){ return Array.prototype.slice.call(root.querySelectorAll('input[name="ef-addon"]:checked')); }

  /* ── Build the basket, in pence ─────────────────────────────────────── */
  function basket() {
    var lines = [], gross = 0, net = 0;

    var p = pit();
    if (p) {
      var pp = parseInt(p.dataset.price, 10);
      lines.push({ id: p.value, quantity: 1, label: p.dataset.label, price: pp });
      gross += pp; net += pp;
    }

    var f = fuel();
    if (f) {
      /* qty is LINES to post, refills is what the shopper is buying. They are
         the same in the UK; in the US one line is a 2-pack, so a Duo is
         qty 1 / refills 2. Everything the shopper reads uses refills;
         everything the cart receives uses qty. */
      var qty  = parseInt(f.dataset.qty, 10) || 1;
      var refills = parseInt(f.dataset.refills, 10) || qty;
      var plan = f.dataset.plan || '';
      /* A pit with its own refill (El Niño) carries its price on the tile; the
         section-level refill keeps reading the root. */
      var tileUnit = parseInt(f.dataset.unit, 10);
      var unit = plan
        ? parseInt(f.dataset.planprice, 10)                 /* real, applied by Shopify */
        : (tileUnit || parseInt(root.dataset.fuelUnit, 10));
      var listUnit = tileUnit || parseInt(root.dataset.fuelUnit, 10);
      /* The strike-through price per posted line. In the US the ladder's
         reduction is already inside the 2-pack price, so the saving shows as
         the gap to its compare-at rather than as a Kaching percentage. */
      var strikeUnit = parseInt(f.dataset.list, 10) || parseInt(root.dataset.fuelList, 10) || listUnit;
      var off  = plan ? 0 : (parseInt(f.dataset.off, 10) || 0);

      var lineGross = strikeUnit * qty;
      /* Match Kaching's arithmetic exactly: it takes the discount off EACH
         UNIT, truncated to the penny, then multiplies. Rounding the line
         total instead is off by 2p at two refills and 3p at four — measured
         against /cart.js on 2026-08-26 (2 × £26.99 came back £48.60, not
         £48.58; 4 × £26.99 came back £91.80, not £91.77). Quoting a total
         a customer does not then see is the whole failure mode this file
         exists to avoid, so copy the app's maths, do not improve on it. */
      var unitOff = Math.floor(listUnit * off / 100);
      var lineNet = plan ? unit * qty : (listUnit - unitOff) * qty;

      /* The tile already reads "Four refills", so appending ×4 in the summary
         gave "4 refills ×4". Name the thing once. */
      var label = plan
        ? (f.closest('label').querySelector('.ef-bld__optname').textContent.trim())
        : (f.dataset.label || (refills + (refills === 1 ? ' wax refill' : ' wax refills')));

      var line = { id: f.value, quantity: qty, units: refills, label: label, price: lineNet };
      if (plan) {
        line.selling_plan = plan;
        /* Kaching's drawer does not render the selling-plan name, so the line
           looked identical to a one-off purchase at a slightly lower price.
           A visible line property makes the recurrence obvious in every cart
           UI, the order confirmation and the packing slip. */
        line.properties = { Delivery: f.dataset.planname || 'Recurring subscription' };
      }
      lines.push(line);
      gross += lineGross; net += lineNet;
    }

    addons().filter(function (a) {
      var lab = a.closest('.ef-bld__opt');
      return !lab || !lab.hidden;
    }).forEach(function (a) {
      var ap = parseInt(a.dataset.price, 10);
      lines.push({ id: a.value, quantity: 1, label: a.dataset.label, price: ap });
      gross += ap; net += ap;
    });

    return { lines: lines, gross: gross, net: net, saved: gross - net };
  }

  /* ── Add-ons that only fit one pit ──────────────────────────────────────
     A Protection Base for an El Fuego must never be offered against an El
     Campo — it is the wrong part and the customer finds out on the doorstep.
     Any add-on carrying data-for-pit is shown only when the chosen pit is in
     that list, and is unchecked on the way out so it cannot linger in the
     basket after the pit changes. */
  function filterAddons() {
    var chosen = pit() ? pit().value : '';
    var any = false;
    Array.prototype.forEach.call(root.querySelectorAll('.ef-bld__opt--add'), function (lab) {
      var only = (lab.dataset.forPit || '').split(',').filter(Boolean);
      var show = !only.length || (chosen && only.indexOf(chosen) !== -1);
      lab.hidden = !show;
      if (!show) {
        var cb = lab.querySelector('input');
        if (cb) cb.checked = false;
      }
      if (show) any = true;
    });
    /* An empty step 3 is worse than no step 3. */
    var step = root.querySelector('.ef-bld__step--addons');
    if (step) step.hidden = !any;
  }

  /* ── Fuel that fits the chosen pit ──────────────────────────────────────
     Each pit radio names a fuel group ("default" = the section's refill). Only
     that group's tiles are shown; if the checked fuel belongs to another group
     it is swapped for the group's default tile, so a basket can never pair El
     Niño with the 4.5kg refill or an El Fuego with the 1kg Duo. */
  function syncFuel() {
    var p = pit();
    var group = (p && p.dataset.fuelGroup) || 'default';
    Array.prototype.forEach.call(root.querySelectorAll('input[name="ef-fuel"]'), function (inp) {
      var lab = inp.closest('.ef-bld__opt');
      var g = (lab && lab.dataset.fuelGroup) || 'default';
      if (lab) lab.hidden = g !== group;
    });
    var cur = fuel();
    var curLab = cur && cur.closest('.ef-bld__opt');
    if (!cur || (curLab && curLab.hidden)) {
      if (cur) cur.checked = false;
      var vis = Array.prototype.filter.call(root.querySelectorAll('input[name="ef-fuel"]'), function (inp) {
        var lab = inp.closest('.ef-bld__opt');
        return !inp.disabled && !(lab && lab.hidden);
      });
      var pick = vis.filter(function (inp) { return inp.dataset.default === '1'; })[0] || vis[0];
      if (pick) pick.checked = true;
    }
  }

  /* ── Paint the summary ──────────────────────────────────────────────── */
  function paint() {
    syncFuel();
    filterAddons();
    var b = basket();

    el.lines.innerHTML = b.lines.map(function (l) {
      /* No ×N suffix on the fuel line — its label already carries the count. */
      var qty = (l.quantity > 1 && !/refill/i.test(l.label)) ? ' <em>×' + l.quantity + '</em>' : '';
      var sub = l.selling_plan ? ' <em>· every 3 months</em>' : '';
      return '<div class="ef-bld__line"><span>' + l.label + qty + sub +
             '</span><span>' + money(l.price) + '</span></div>';
    }).join('');

    if (b.saved > 0) {
      el.save.hidden = false;
      el.save.innerHTML = '<span>You save</span><span>' + money(b.saved) + '</span>';
    } else {
      el.save.hidden = true;
    }

    el.total.textContent = b.lines.length ? money(b.net) : '—';

    /* Mirror into the sticky bar so it can never quote a stale price — but
       only once the visitor has touched the builder, for the same reason the
       button waits. Summarising "5 items — £291.79" at load is summarising a
       basket nobody chose, and it anchors the highest number on the page
       before the visitor has been asked a single question. Until then the bar
       keeps its Liquid defaults: an invitation, not a receipt. Those defaults
       also stay put on any LP with no builder on it. */
    if (el.stickyTitle && engaged && b.lines.length) {
      /* Count units, not lines — "4 wax refills" is four items to a shopper,
         one row to us, and the bar is there to tell them what they have.
         A US 2-pack is ONE line carrying TWO refills, so count l.units where
         the line declares it; quantity alone would undercount the basket. */
      var units = b.lines.reduce(function (n, l) { return n + (l.units || l.quantity); }, 0);
      el.stickyTitle.textContent =
        units + (units === 1 ? ' item' : ' items') + ' — ' + money(b.net);
    }
    if (el.stickySub && engaged) {
      /* The delivery clause is rendered by Liquid, not written here. US rates
         are tiered, not free, so a hard-coded "free UK delivery" was a false
         claim on every US basket. Empty attribute = say nothing. */
      var ship = root.dataset.shipNote || '';
      el.stickySub.textContent = b.saved > 0
        ? 'You save ' + money(b.saved) + (ship ? ' · ' + ship : '')
        : (el.stickySub.dataset.base || el.stickySub.textContent);
    }

    var ready = !!pit() && !!fuel();
    el.cta.disabled = !ready;
    el.cta.classList.toggle('is-disabled', !ready);
    if (!pit()) el.cta.textContent = 'Pick a fire pit';
    else if (!fuel()) el.cta.textContent = 'Pick your fuel';
    else el.cta.textContent = el.cta.dataset.label || (el.cta.dataset.label = 'Add to cart', 'Add to cart');

    /* The sticky bar's button follows the same rule, one step behind: it only
       becomes a buy button after the visitor has touched the builder AND the
       basket is complete. Otherwise it stays the link its Liquid set up, which
       scrolls to the builder — the right destination when there is nothing to
       buy yet, and the graceful state on any LP with no builder at all. */
    if (el.stickyBtn) {
      var atc = engaged && ready;
      el.stickyBtn.dataset.efAtc = atc ? '1' : '0';
      if (!el.stickyBtn.dataset.busy) {
        el.stickyBtn.textContent = atc ? 'Add to cart' : el.stickyBtn.dataset.base;
      }
    }
  }

  /* Both buttons that can fire an add. A visitor who tapped the sticky bar
     must not have to hunt for the outcome on a button 900px up the page, so
     whichever one they used reports progress in place. */
  function ctas() {
    var list = [el.cta];
    if (el.stickyBtn && el.stickyBtn.dataset.efAtc === '1') list.push(el.stickyBtn);
    return list;
  }

  /* ── Add to cart ────────────────────────────────────────────────────────
     Open the drawer, never navigate. Sending the visitor to /cart after they
     have just configured a bundle throws away the page they were converting
     on and makes them find their way back.

     Dawn's drawer wants the rendered section HTML back with the cart JSON, so
     the section ids go out with the request and the response is handed to
     renderContents. If the drawer is not there — cart_type set to page, or an
     app has replaced it — fall through to a plain navigation rather than
     silently doing nothing. */
  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function openCart(state) {
    var d = drawer();

    if (d && typeof d.renderContents === 'function' && state && state.sections) {
      d.classList.remove('is-empty');
      d.renderContents(state);
      return true;
    }
    /* Kaching Cart and most drawer apps listen for one of these. */
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:build', { bubbles: true })
    );
    if (d && typeof d.open === 'function') { d.open(); return true; }
    return false;
  }

  function add() {
    var b = basket();
    if (!b.lines.length) return;

    el.err.hidden = true;
    el.cta.disabled = true;

    var buttons = ctas();
    var was = buttons.map(function (btn) { return btn.textContent; });
    buttons.forEach(function (btn) {
      /* The busy flag stops paint() — which a change event could fire while
         the request is in flight — from overwriting "Adding…" mid-add. */
      btn.dataset.busy = '1';
      btn.textContent = 'Adding…';
    });
    function restore() {
      buttons.forEach(function (btn, i) {
        delete btn.dataset.busy;
        btn.textContent = was[i];
      });
      el.cta.disabled = false;
    }

    var items = b.lines.map(function (l) {
      var o = { id: Number(l.id), quantity: l.quantity };
      if (l.selling_plan) o.selling_plan = Number(l.selling_plan);
      if (l.properties) o.properties = l.properties;
      return o;
    });

    var payload = { items: items };
    var d = drawer();
    if (d && typeof d.getSectionsToRender === 'function') {
      payload.sections = d.getSectionsToRender().map(function (x) { return x.id; });
      payload.sections_url = window.location.pathname;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || 'Could not add that to the cart.');
          return data;
        });
      })
      .then(function (state) {
        if (root.dataset.cartAction === 'checkout') {
          window.location.href = '/checkout';
          return;
        }
        buttons.forEach(function (btn) { btn.textContent = 'Added'; });
        var opened = openCart(state);
        document.dispatchEvent(new CustomEvent('ef:cart:updated', { bubbles: true }));

        if (!opened) {
          window.location.href = '/cart';
          return;
        }
        setTimeout(restore, 1400);
      })
      .catch(function (e) {
        /* Almost always an out-of-stock variant that was in stock when the page
           rendered. Say so plainly rather than failing silently. */
        el.err.hidden = false;
        el.err.textContent = e.message;
        restore();
        /* The error prints inside the builder. Someone who tapped the sticky
           bar could be a long way down the page from it, so an unexplained
           button reverting to "Add to cart" is all they would see. Bring the
           message to them. */
        var box = el.err.getBoundingClientRect();
        if (box.bottom < 0 || box.top > window.innerHeight) {
          el.err.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
  }

  /* A "Full details" link sits inside the tile's <label>, so a click on it
     would also toggle the radio. The navigation wins either way, but stopping
     propagation means the option does not flicker selected on the way out —
     and if the new tab is blocked, the visitor has not silently had their
     configuration changed by trying to read about a product. */
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-ef-more]')) e.stopPropagation();
  });

  root.addEventListener('change', function () {
    engaged = true;
    paint();
  });
  el.cta.addEventListener('click', add);

  /* The sticky button stays an anchor to #offer. That is deliberate: leaving
     the href in place means it keeps working if this script never runs, and
     it makes the not-yet-engaged state free — no handler, just a link. When
     it has switched to buy mode we swallow the navigation instead. Enter on a
     focused anchor fires click, so the keyboard path works either way. */
  if (el.stickyBtn) {
    el.stickyBtn.addEventListener('click', function (e) {
      if (el.stickyBtn.dataset.efAtc !== '1') return;
      e.preventDefault();
      add();
    });
  }

  paint();
})();
